import useHierarchyItemContext from '@components/UI-Components/HierarchyWiseItems/hooks/use-hierarchy-item-context'
import { useObserver } from 'mobx-react-lite'
import { useContext, useMemo } from 'react'
import RendererContext from '../contexts/renderer-context'

const useScrollRange = () => {
  return useObserver(function useHook() {
    const { width } = useContext(RendererContext)
    const {
      store: {
        scrollPositionStore: { scrollLeft }
      }
    } = useHierarchyItemContext()
    return useMemo(() => {
      return scrollLeft === 0
        ? [scrollLeft, scrollLeft + width + 500]
        : scrollLeft > 500
        ? [scrollLeft - 200, scrollLeft + width + 300]
        : [scrollLeft - 200, scrollLeft + width + 300]
    }, [scrollLeft, width])
  })
}

export default useScrollRange
